var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.getStringValue),expression:"getStringValue",arg:"copy"}],staticClass:"entry-copy",attrs:{"type":"button"},on:{"click":_vm.handleCopyIndicator}},[_c('span',{staticClass:"button"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }